import axios from "axios";
import Config from "../utils/Config";

class ContactUsAPI {
  config = {
    headers: {
      Authorization: "",
      GroupId: "",
      CompanyId: "",
    },
  };

  setAccessToken(accessToken, groupId, companyId) {
    this.config.headers.Authorization = accessToken;
    this.config.headers.GroupId = groupId;
    this.config.headers.CompanyId = companyId;
  }

  //send email ContactUs
  async sendEmail(accessToken, groupId, companyId, formData) {
    this.setAccessToken(accessToken, groupId, companyId);
    console.log("contactapi", formData);
    const data = await axios.post(
      `${Config.BACKEND_URL}/api/contact`, // Correct URL
      formData,
      {
        ...this.config,
        headers: {
          ...this.config.headers,
          'Content-Type': 'multipart/form-data', // Ensure proper content type for file uploads
        },
      }
    );
    console.log("Backend URL:", `${Config.BACKEND_URL}/api/contact`);
    return data.data;
  }
}

export default new ContactUsAPI();
